// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__kKEW0","dynamicFlex":"Header_dynamicFlex__bCR12","logoLink":"Header_logoLink__w9XbH","nav":"Header_nav__J8WFt"};